import '@ionic/core';
import { Component, Event, EventEmitter, Prop, h, State, Watch } from '@stencil/core';

import { retrieveSelectorData } from '../../utils/tools';

@Component({
    tag: 'selector-opportunity-type',
    styleUrl: 'selector-opportunity-type.css',
    shadow: true,
})

export class OpportunityTypeSelector {
    // The cohort from which partners will be selected.
    @Prop() cohortId = 0;

    // The list of opportunity types 
    @Prop() typeSelections: Array<string>;

    // Thhe number of opportunity types selected.
    @State() selectedCount: number;

    // A flag denoting whether the partners list is loaded.
    @State() opportunitiesLoaded: boolean = false; 

    @Watch('typeSelections') 
    watchHandler(newValue: Array<string>) {
        // console.log(`Updated types property in selector-opportunity-type component, newValue: ${newValue}, oldValue: ${oldValue}`);
        //this.typeSelections = newValue;
        this.selectedCount = newValue.length
    }

    @Event() typeSelectionCompleted: EventEmitter;

    private opportunityTypeList: Array<any> = []

    private firstRun: boolean = true;

    private updateTypesSelected = (e: any) => {
        try {
            this.selectedCount = e.detail.value.length;
        } catch (error) {
            this.selectedCount = 0;
        }
        
        this.typeSelectionCompleted.emit(e.detail.value);
    }

    // The base URL for data.
    private baseUrl: string = `https://storage.googleapis.com/sspb-static-assets/`; 

    private processTypes = (rawOppos: Array<any>) => {
        if(rawOppos.length > 0) {
            const formattedOppoList = [];

            rawOppos.forEach(oppo => {
                formattedOppoList.push({
                    value: oppo.value,
                    label: oppo.label,
                    disabled: false
                });
            });

            this.opportunitiesLoaded = true;

            this.opportunityTypeList = formattedOppoList;
        }

        console.log(`Updated list of opportunitiy types for cohort ${this.cohortId}.`);

        this.render();
    }

    private retrieveData = async (basePath, filename) => {
        try {
            // return await axios.get(basePath.concat(filename), {timeout: 1000})
            return await retrieveSelectorData(basePath.concat(filename))
        } catch(retrError) {
            console.error(`FAILURE requesting opportunity type data from: ${filename}.`, retrError)

            throw new Error('DataRetrievalFailure')
        }
    }

    private loadOpportunityTypes = async () => {
        console.log(`Requesting list of current opportunity types for cohort ${this.cohortId}.`);

        const that = this;

        let response: any = {};

        try {
            response = await this.retrieveData(this.baseUrl, `c${that.cohortId}-opporunity-types.json`)

            console.log(`Successfully retrieved cohort-specific opportunity data for cohort: ${that.cohortId}`)
        } catch(fetchError) {
            console.log(`Trying to retrieve default non-cohort-specific data.`)

            try {
                response = await this.retrieveData(this.baseUrl, 'global-opporunity-types.json')

                console.log(`Successfully retrieved non-cohort-specific opportunity type data.`)
            } catch(defaultFetchError) {
                console.error(`FAILURE loading opportunitiy type data.`)

                response.data = { data: [] };
            }   
        }

        let typeData: any;

        try {
            typeData = response.data
        } catch (parseError) {
            console.error('FAILURE parsing opportunity type data.')

            typeData = []
        }
        
        that.processTypes(typeData);
    }

    componentWillLoad() {
        if(this.firstRun) {
            try {
                this.selectedCount = this.typeSelections.length;
            } catch (error) {
                this.selectedCount = 0;
            }
    
            this.firstRun = false;
        }

        this.loadOpportunityTypes();
    }

    selectClicked() {
        /* const alertElement = document.querySelector('ion-alert.SSPBOpportunityTypeSelectorAlert');
        alertElement.setAttribute("style", "position: fixed; height: 100vh;");
        console.log('Updated ion-alert position for opportunity-type select'); */
        return;
    }

    render() {
        return ( 
            <div id="OpportunityTypeSelectorStage">
              <ion-item>
                <ion-select label="Opportunity Types" onIonBlur={this.selectClicked}
                  interfaceOptions={{cssClass: 'SSPBOpportunityTypeSelectorAlert'}}
                  id="SSPBOpportunityTypeSelector" value={this.typeSelections} multiple={true}
                  onIonChange={this.updateTypesSelected} selectedText={`${this.selectedCount} selected`}>
                  {this.opportunityTypeList.map( type => {
                  return (
                  <ion-select-option value={type.value}>{type.label}</ion-select-option>
                  );
                  })}
                </ion-select>
              </ion-item>
            </div>
        );
    }
}
